import api from './api';

export const trialDataEntryApiService = {
  // =============================================================================
  // TRIAL DATA ENTRY API ENDPOINTS
  // =============================================================================

  // GET /trial-data-entry
  // Get all trial data entries with pagination and filtering
  async getTrialDataEntries(params = {}) {
    try {
      const response = await api.get('/trial-data-entry', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial data entries');
    }
  },

  // GET /trial-data-entry/:id
  // Get trial data entry by ID
  async getTrialDataEntry(id) {
    try {
      const response = await api.get(`/trial-data-entry/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial data entry');
    }
  },

  // POST /trial-data-entry
  // Create new trial data entry
  async createTrialDataEntry(data) {
    try {
      const response = await api.post('/trial-data-entry', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create trial data entry');
    }
  },

  // PUT /trial-data-entry/:id
  // Update trial data entry
  async updateTrialDataEntry(id, data) {
    try {
      const response = await api.put(`/trial-data-entry/${id}`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update trial data entry');
    }
  },

  // DELETE /trial-data-entry/:id
  // Delete trial data entry
  async deleteTrialDataEntry(id) {
    try {
      const response = await api.delete(`/trial-data-entry/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete trial data entry');
    }
  },

  // GET /trial-data-entry/officer/:id
  // Get trial data entries by officer ID
  async getTrialDataEntriesByOfficer(officerId, params = {}) {
    try {
      const response = await api.get(`/trial-data-entry/officer/${officerId}`, { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial data entries by officer');
    }
  },

  // POST /upload/image
  // Upload image file
  async uploadImage(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await api.post('/upload/image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to upload image');
    }
  },

  // GET /upload/document/:id/download
  // Download document by ID
  async downloadDocument(id) {
    try {
      const response = await api.get(`/upload/document/${id}/download`, {
        responseType: 'blob', // Important for file downloads
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to download document');
    }
  }
};
